export default __webpack_public_path__ + "static/media/profile.da917c0d.jpeg";